export default __webpack_public_path__ + "static/media/major-yd.af58a2f7.png";